<template>
  <div class="">
    <div class="card purple">
      <div class="card-body">
        <div class="header right">
          회원가입일 {{formatterDate(userInfo.join_dt)}} | 마지막 로그인 {{formatterDateTime(userInfo.last_login_dt)}}
        </div>
        <div class="media">
          <img src="/static/img/user-shadow@3x.png" alt="user photo" class="avatar" />
          <div class="media-body">
            <h5>{{userInfo.name}}<span class="light-mint badge align-middle">{{userInfo.user_type_name}}</span></h5>
            관리자 정보
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body small">
        <div class="card-title">
        </div>
      </div>
        <div class="dashboard d-flex">
          <div class="p-2 dashboard-sidebar">
            <div class="media">
              <img src="/static/img/usercopy.png" />
              <div class="media-body">
                <h6 class="number student"><countTo class="number-bold" :startVal="0" :endVal="userCount.cnt_student" :duration="countDuration"></countTo></h6>
                <a href="#" onclick ="return false;">학생</a>
              </div>
            </div>
            <div class="media">
              <img src="/static/img/tutor_2@3x.png" />
              <div class="media-body">
                <h6 class="number manager"><countTo class="number-bold" :startVal="0" :endVal="userCount.cnt_manager" :duration="countDuration"></countTo></h6>
                <a href="#" onclick ="return false;">선생님</a>
              </div>
            </div>
            <div class="media">
              <img src="/static/img/admin_2@3x.png" />
              <div class="media-body">
                <h6 class="number admin"><countTo class="number-bold" :startVal="0" :endVal="userCount.cnt_admin" :duration="countDuration"></countTo></h6>
                <a href="#" onclick ="return false;">관리자</a>
              </div>
            </div>
            <div class="media">
              <img src="/static/img/usercopy.png" />
              <div class="media-body">
                <h6 class="number total"><countTo class="number-bold" :startVal="0" :endVal="userCount.cnt_total_user" :duration="countDuration"></countTo></h6>
                <a href="#" onclick ="return false;">시스템 총 이용자</a>
              </div>
            </div>
          </div>
          <div class="p-2 w-100 dashboard-body">
            <template v-for="data in dashboardData">
              <div v-if="data.lvl === 1 && data.is_leaf === 0" :key="data.rnum" class="day">
                <template v-if="data.lvl === 1 && data.is_leaf === 0">
                  <span v-if="data.to_day_yn === 'Y'" class="badge eng strong lavender align-middle">TODAY</span>
                  <h3 class="number">{{formatterDate(data.tmp_date)}} <span class="kor">{{data.day_name + '요일'}}</span></h3>
                    <template v-for="sub in dashboardData">
                      <template v-if="sub.exam_date === data.tmp_date">
                        <p :key="sub.rnum" v-if="sub.stat === 'O'" class="test-start"><strong>{{sub.title}}</strong>{{searchJosa(sub.title, '이/가')}} 공개 되었습니다. ({{formatterDateTime(sub.exam_dt)}})</p>
                        <p :key="sub.rnum" v-else class="test-end"><strong>{{sub.title}}</strong>{{searchJosa(sub.title, '이/가')}} 종료 되었습니다. ({{formatterDateTime(sub.exam_dt)}})</p>
                        <a :key="'a' + sub.rnum" href="#"></a>
                      </template>
                  </template>
                </template>
              </div>
            </template>
          </div>
        </div>
    </div>

    <div class="card">
      <div class="card-body small">
        <div class="card-title d-flex">
          <div class="p-2"><strong>공지사항</strong></div>
        </div>
      </div>
      <!-- 공지사항 -->
      <stone-data-table
        :loading="searchLoading"
        :columns="noticeColumns"
        :data="noticeData"
        :table-props="noticeProps"
        :page-size="emptyPageSize"
        :pagination-props="emptyPaginationProps"
        @row-click="handleNoticeRowClick">
      </stone-data-table>
    </div>

    <notice ref="notice"></notice>

  </div>
</template>

<script>

import common from '@/modules/common'
import countTo from 'vue-count-to'
import notice from '@/pages/components/Notice.vue'

export default {
  name: 'MAIN',
  mixins: [common.mixins],
  components: {countTo, notice},
  data () {
    return {
      today: this.getToday(),
      userCount: {
        cnt_admin: 0,
        cnt_manager: 0,
        cnt_student: 0,
        cnt_total_user: 0
      },
      userInfo: {
        name: '',
        user_type_name: '',
        join_dt: '',
        last_login_date: '',
        last_login_dt: ''
      },
      countDuration: 1000,
      noticeData: [],
      noticeColumns: [
        {label: '작성일', prop: 'reg_dt', align: 'center', width: 100},
        {label: '제목', prop: 'title', align: 'left', width: 300},
        {label: '공개', prop: 'open_yn_name', align: 'center', width: 100}
      ],
      noticeProps: {height: 300},
      dashboardData: []
    }
  },
  created () {
    this.getUserInfo()
    this.getUserCount()
    this.retreiveNotice()
    this.retreiveDashboard()
  },
  methods: {
    getUserInfo () {
      common.axios.get('/user/load/' + this.$store.getters.user_seq)
        .then(response => {
          const result = response.data
          Object.keys(this.userInfo).forEach(key => {
            this.userInfo[key] = this.isEmpty(result[key]) ? '' : result[key]
          })
        })
    },
    getUserCount () {
      common.axios.get('/user/count')
        .then(response => {
          this.userCount = response.data
        })
    },
    retreiveNotice () {
      this.loadStoneDataTable('/board/notice/user/' + this.$store.getters.user_seq, null, false)
        .then(response => {
          this.noticeData = response.data
        })
        .catch(() => {
        })
    },
    retreiveDashboard () {
      common.axios.get('/stats/dashboard/' + this.$store.getters.user_seq)
        .then(response => {
          // console.log(response.data)
          this.dashboardData = response.data
        })
        .catch(() => {
        })
    },
    handleNoticeRowClick (row) {
      this.handleNoticeDiallogLoad(row.board_seq)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Main.vue